import HttpResponse from "../../../../../utils/http/http.response";

export type OrderCargoOrderDetailsComplexResponseDataNodeExclusions = {
  nodeIds: string[];
  excludeApproaching: boolean;
  excludeInside: boolean;
  excludeReturning: boolean;
};

export type OrderCargoOrderDetailsComplexResponseDataDispatcher = {
  id: string;
};

export type OrderCargoOrderDetailsComplexResponseDataTransportingOrderDriver = {
  id: string;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
};

export enum OrderCargoOrderDetailsComplexResponseDataPassengerType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export type OrderCargoOrderDetailsComplexResponseDataPassengerInternal = {
  itemType: OrderCargoOrderDetailsComplexResponseDataPassengerType.INTERNAL;
  firstName: string;
  lastName: string;
  phonePrefix: string;
  phoneNo: string;
  cargoItemId: string;
  passengerId: string;
};

export type OrderCargoOrderDetailsComplexResponseDataPassengerExternal = {
  itemType: OrderCargoOrderDetailsComplexResponseDataPassengerType.EXTERNAL;
  firstName: string;
  lastName: string;
  phonePrefix: string;
  phoneNo: string;
  cargoItemId: string;
};

export type OrderCargoOrderDetailsComplexResponseDataPassenger =
  | OrderCargoOrderDetailsComplexResponseDataPassengerInternal
  | OrderCargoOrderDetailsComplexResponseDataPassengerExternal;

export type OrderCargoOrderDetailsComplexResponseDataSolveNode = {
  nodeId: string;
  lat: number;
  lon: number;
  requestedTime: Date | null;
  requestedHaltingTime: number;
  displayName: string;
  cargoEnter: string[];
  cargoExit: string[];
  estimatedTime: Date;
  distance: number;
};

export type OrderCargoOrderDetailsComplexResponseDataSolveStage =
  | OrderCargoOrderDetailsComplexResponseDataSolveNode
  | OrderCargoOrderDetailsComplexResponseDataSolveNode[];

export type OrderCargoOrderDetailsComplexResponseDataDriverSolveNodeCheckoutEvent =
  {
    achievedAt: Date;
  };

export type OrderCargoOrderDetailsComplexResponseDataDriverSolveNode = {
  nodeId: string;
  checkoutEvent: OrderCargoOrderDetailsComplexResponseDataDriverSolveNodeCheckoutEvent | null;
};

export type OrderCargoOrderDetailsComplexResponseDataCandidatureDriver = {
  id: string;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
  mobileSecondaryPrefix: string | null;
  mobileSecondary: string | null;
};

export type OrderCargoOrderDetailsComplexResponseDataCandidature = {
  id: string;
  createdBy: string;
  createdAt: Date;
  modifiedBy: string | null;
  modifiedAt: Date | null;
  driver: OrderCargoOrderDetailsComplexResponseDataCandidatureDriver;
  candidatureId: string;
};

export type OrderCargoOrderDetailsComplexResponseDataTransportingOrder = {
  id: string;
  driver: OrderCargoOrderDetailsComplexResponseDataTransportingOrderDriver | null;
  planEntryId: string | null;
  planEntryHumanId: number | null;
  passengers: OrderCargoOrderDetailsComplexResponseDataPassenger[];
  solve: OrderCargoOrderDetailsComplexResponseDataSolveStage[];
  driverSolve:
    | OrderCargoOrderDetailsComplexResponseDataDriverSolveNode[]
    | null;
  createSolvedOrderEntries: OrderCargoOrderDetailsComplexResponseDataCandidature[];
  createPlanEntryEntries: OrderCargoOrderDetailsComplexResponseDataCandidature[];
};

export type OrderCargoOrderDetailsComplexResponseData = {
  id: string;
  humanId: number;
  targetTaxiId: string | null;
  externalId: string | null;
  isPublished: boolean | null;
  isFinished: boolean;
  isCancelled: boolean;
  isCancelRequested: boolean;
  contactPassengerAfterMinutes: number;
  cancelByTaxiAllowed: boolean;
  editByTaxiAllowed: boolean;
  nodeExclusions: OrderCargoOrderDetailsComplexResponseDataNodeExclusions;
  dispatcher: OrderCargoOrderDetailsComplexResponseDataDispatcher;
  transportingOrders: OrderCargoOrderDetailsComplexResponseDataTransportingOrder[];
};

type OrderCargoOrderDetailsComplexResponse =
  HttpResponse<OrderCargoOrderDetailsComplexResponseData>;

export default OrderCargoOrderDetailsComplexResponse;
